import React, { Component } from 'react'
import injectSheet from 'react-jss'
import { flexUtils, palette } from '../../../Theme/Theme'
import Color from 'color'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as Actions from '../../../Actions/Actions'
import { apiUrl } from '../../../Utility'
// import ReactGA from 'react-ga'

class Coupon extends Component {
    constructor(props) {
        super(props)
        this.state = {
            code: '',
            message: null
        }
    }

    render () {
        const { classes } = this.props
        return (
            <div className={classes.Container}>
                <h1 style={{margin: '3rem 3rem 1rem 3rem'}}>Enter your code.</h1>
                {this.state.message ? <span style={{color: palette.orange}}>{this.state.message}</span> : null}
                <input type="text" placeholder='code' value={this.state.code} onChange={this.onChange}/>
                <div className={classes.ActionContainer}>
                    <button className={classes.CancelButton} onClick={this.onCancel}>Cancel</button>
                    <button className={classes.SubmitButton} onClick={this.onSubmit}>Submit</button>
                </div>
            </div>
        )
    }

    componentDidMount () {
        // ReactGA.pageview('/Home/Coupon');
    }      

    onChange = e => {
        this.setState({ code: e.target.value, message: null })
    }

    onCancel = () => {
        this.props.history.push('/Home/AccountInfo')
    }

    onSubmit = () => {
        const { user, dispatch, history } = this.props
        const req = new Request(`https://${apiUrl}/api/v1/coupon_check`, {
            method: 'POST',
            body: JSON.stringify({ couponCode: this.state.code }),
            headers: new Headers({
                'Content-Type': 'application/json'
            })
        })

        fetch(req)
            .then(response => {
                response.json().then(data => {
                    // console.log(data)
                    return
                    if (data.status === 'failure') {                        
                        this.setState({ message: data.message })
                        return
                    } else {
                        // console.log(data)
                        if (user.payments.plan.includes('month') && !data.couponDetails.appliesMonthly) {
                            this.setState({message: 'That coupon is only for annual plans'})
                            return
                        }
                        if (user.payments.plan.includes('annual') && !data.couponDetails.appliesAnnual) {
                            this.setState({message: 'That coupon is only for monthly plans'})
                            return
                        }
                        this.setState({message: 'Success!'})
                        setTimeout(() => {
                            const reqBody = {
                                payments: {
                                    platform: 'stripe',
                                    plan: user.payments.plan,
                                    couponCode: this.state.code
                                }
                            }
                            dispatch(Actions.updateUser(user.token, reqBody, history))
                        }, 1000);
                    }
                })
            })
    }
}

const styles = {
    ...flexUtils,
    Container: {
        composes: ['$FlexColumn', '$FlexCenter'],
        height: '50%',
        color: palette.white,
        '& h1': {
            textAlign: 'center'
        },
        '& input': {
            color: palette.white,
            marginTop: '1.5rem',
            width: '17rem',
            background: 'rgba(0, 0, 0, 0)',
            border: 'none',
            borderBottom: '1px solid rgb(200, 200, 200)',
            fontSize: '1.7rem',
            '&:focus': {
                outline: 'none'
            }
        }
    },
    ActionContainer: {
        composes: ['$FlexRow', '$FlexCenter']
    },
    Button: {
        color: 'rgb(50, 50, 50)',
        fontSize: '1.1rem',
        fontWeight: '600',
        margin: '1.5rem .7rem',
        width: '8rem',
        height: '2.6rem',
        borderRadius: '5px',
        border: 'none',
        '&:focus': {
            outline: 'none'
        },
        '&:hover': {
            cursor: 'pointer'
        }
    },
    CancelButton: {
        composes: '$Button'
    },
    SubmitButton: {
        composes: '$Button',
        background: palette.blue,
        color: palette.white,
        transition: 'background .5s',
        '&:hover': {
            background: `${Color(palette.blue).darken(0.3)}`
        }
    }
}

const mapStateToProps = state => {
    return {
        user: state.mainState.user
    }
}

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(Coupon)))


// WEBPACK FOOTER //
// ./src/js/Components/Home/Settings/Coupon.jsx